const SchedulingPage = () => {
  return <div>Scheduling</div>;
};

export default SchedulingPage;
